import { render } from "./index.vue?vue&type=template&id=3406af03"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3406af03&lang=scss"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__